// extracted by mini-css-extract-plugin
module.exports = {"background":"BaseSlider_background__TicnK","container":"BaseSlider_container__u0mXB","slider":"BaseSlider_slider__2APT_"};